import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const GIG_API = `${BACKEND}/api`;
export const GIG_TOKEN_KEY = "rescigo_gig_token";
export const GIG_PARTNER_KEY = "rescigo_gig_partner";

export const gigApi = axios.create({ baseURL: GIG_API, timeout: 30000 });
gigApi.interceptors.request.use(cfg => {
  const t = localStorage.getItem(GIG_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
gigApi.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401) {
      localStorage.removeItem(GIG_TOKEN_KEY);
      localStorage.removeItem(GIG_PARTNER_KEY);
    }
    return Promise.reject(e);
  },
);

export function gigFormatErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x.msg).join("; ");
  return e?.message || "Something went wrong";
}
